var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"configurator__top-btn btn",attrs:{"disabled":_vm.moduleConfigurator.steps.length < 3},on:{"click":_vm.CLEAR_ALL}},[_vm._v("Сбросить")])
}
var staticRenderFns = []

export { render, staticRenderFns }